module.exports = __webpack_public_path__ + "fonts/Gilroy-ExtraBold.4c95fd1a.woff2";